import qs from 'qs'

import api from '@/client/core/api'
import { AccountSearchResponse, GetAccountsSearchQuery } from '@/typings/twitter_benchmark_campaign_posts'

import { TwBenchmarkApiResponse, TwBenchmarkApiResult, handleApiResponse } from './twBenchmarkApiError'

/**
 * GET /twitter_benchmark_campaign_posts/accounts/search
 */
export async function searchTwBenchmarkAccounts(
  query: GetAccountsSearchQuery
): Promise<TwBenchmarkApiResult<AccountSearchResponse>> {
  const response = await api.get<TwBenchmarkApiResponse<AccountSearchResponse>>(
    '/twitter_benchmark_campaign_posts/accounts/search',
    {
      params: query,
      paramsSerializer: (params: Record<string, unknown>) => qs.stringify(params, { arrayFormat: 'brackets' })
    }
  )

  return handleApiResponse<AccountSearchResponse>(response)
}
